export const CONCHA_TRASEIRA_CT300 = {
    Codigo: 5,
    Nome: 'Concha Traseira CT-300',
    Modelo: 'CT-1300',
    Capa: null, 
    Imagens: [
        {
            Capa: true,
            Ativo: true,
            Url: "assets/IPB/Produtos/Concha_Traseira_CT-300/concha_traseira_3.png"
        }
        , {
            Url: "assets/IPB/Produtos/Concha_Traseira_CT-300/concha_traseira_2.png"
        }
        , {
            Url: "assets/IPB/Produtos/Concha_Traseira_CT-300/concha_traseira_1.png"
        }
    ],
    Detalhes: [
        `Acionamento Hidráulico ou Manual`,
        `Capacidade de 300 litros`
    ],
    Modelos: [
        { Modelo: 'CT-300', Detalhes: 'Hidráulica' },
        { Modelo: 'CT-300', Detalhes: 'Manual' }
    ]
}